
<template>
    <b-modal id="privacy-modal" hide-header hide-footer size="lg">
        <button type="button" aria-label="Close" class="close modal-close" @click="$bvModal.hide('privacy-modal')">×</button>
        <h1>{{$t('general.privacy_policy')}}</h1>
        <p v-html="$t('general.privacy_policy_content')"></p>
    </b-modal>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {

        }
    }
</script>
